<!-- 主页面 -->
<template>
  <div  class="pc-home-com">
    <TxBg src="oldclassic_p_home_beijin2">
      
      

      <div class="pc-rank">
        <Select
          v-for="(nav, index) in nav_list"
          :src="nav.src"
          :op="nav.op"
          :key="index"
          :order_key="nav.order_key"
          @selectItem="selectItem"
        />
      </div>
      
      <Link />
    </TxBg>
  </div>
</template>
  
<script setup>
import { useRouter } from 'vue-router';
import Select from './components/home/Select.vue';
import Link from './components/link.vue';
const { is_mobile, schools, sectors, rank_type } = inject('GlobalStore');

const router = useRouter();


const school_op = computed(() => {
  const tmp = Object.entries(schools.value).map(([value, text]) => {
    return { text, value };
  });
  // tmp.unshift({ text: '所有门派', value: '' });
  return tmp;
});

const nav_list = computed(() => {
  return [
    {
      src: 'renwuxiuwei',
      op: school_op.value,
      order_key: 'xiuwei',
    },
    {
      src: 'zhuangping',
      op: school_op.value,
      order_key: 'equ_xiuwei',
    },
    {
      src: 'zongxiuwei',
      op: school_op.value,
      order_key: 'total_xiuwei',
    },
  ];
});

const selectItem = (school, order_key) => {
  console.log('selectItem', school, order_key);
  router.push({
    path: `/rank`,
    query: {
      school,
      order_key,
    },
  });
};
</script>
<style lang="scss" scoped>
.pc-home-com {
  display: flex;
  justify-content: center;
  width: 100vw;
}




.pc-rank {
  display: flex;
  top: 520px;
  position: absolute;
  align-items: center;
  width: 100%;
  justify-content: center;
}
</style>
  